import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";

export class CompetitionsResponseApiModel extends BaseApiResponseModel {
  countries: Array<CountryApiModel>;
  sports: Array<SportApiModel>;
  competitions: Array<CompetitionApiModel>;

  constructor(model: CompetitionsResponseApiModel) {
    super(model);

    this.countries = model?.countries;
    this.sports = model?.sports;
    this.competitions = model?.competitions;
  }
}
